import React, { useEffect, useLayoutEffect, useState } from 'react';
import liff from '@line/liff';
import axios from 'axios';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Container, Typography } from '@mui/material';
// liff
// components
import Page from '../components/Page';
import BingFrom from '../components/authentication/BingFrom';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));


const Form = ({ region, cityobj }) => {

  switch (region) {
    case '彰化縣':
      return <BingFrom cityobj={cityobj} />;
    case '高雄市':
      return <BingFrom cityobj={cityobj} />;
    case '台南市':
      return <BingFrom cityobj={cityobj} />;
    case '澎湖縣':
      return <BingFrom cityobj={cityobj} />;
    case '桃園市':
      return <BingFrom cityobj={cityobj} />;
    case '嘉義市':
      return <BingFrom cityobj={cityobj} />;
    default:
      return <BingFrom cityobj={cityobj} />;
  }
};


export default function Binging({ region }) {
  const [cityObj, setCityObj] = useState({ webtitle: '' });

  const getCity = async () => {
    try {
      const response = await axios.get(
        `https://api.smartbustw.com/api/line/getcitysitting`
      );

      if (response.data.code === 0) {
        response.data.data.forEach((element) => {
          if (element.region === region) {
            setCityObj(element);
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      await getCity();
    }

    fetchData();
  }, []);

  useLayoutEffect(() => {
  }, [cityObj]);

  return (
    <RootStyle title={cityObj.webtitle}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {cityObj.webtitle}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>輸入你的帳密</Typography>
          </Stack>
          <BingFrom cityobj={cityObj} />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
